import PropTypes from "prop-types";

export const _NoPosts = {
  postType: PropTypes.string,
  category: PropTypes.string,
  background: PropTypes.bool,
};

export const NoPostsPropTypes = _NoPosts;
